module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAmCAYAAABH/4KQAAAACXBIWXMAAAsSAAALEgHS3X78AAAA30lEQVRYhe2VzQ3CMAxGPyzuXYEN4OABGKkjlA0YzId2A0YgExSBjIQqhyJLLjn4k3pJ/Jqfyn27eZ7RavbvfTHzAKAH0OlQAXB9PiJyr+0/knvdHDOPAI6V9ScAZ2uD0RzpCWqF0Lm+cvJQjqyFjVg14Rx9fPNv6Zj5sJgP5+iHwr+FtEvWUkTktqgJ50jbdy1WTThHIjJo+9YyWS/cgiMFTgAuiysvOmb+47bgmtZX893abFL8Xi7F7+VS/N6k+L1cit/Lpfi9SfF7uRS/l0vxe7kUv5dL8Xu5FL8rAB5OLGKy2ur8WAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/dn_ -37.png
// module id = ajbX
// module chunks = 1